{
  "flaggedStacksPresenter": {
    "title": "Configuraciones marcadas",
    "columns": {
      "id": "ID",
      "hangar": "Hangar",
      "date": "Fecha"
    },
    "buttons": {
      "view": "Ver"
    }
  }
}
